import React, { useState, useEffect } from 'react';
import '../styles/LoadingScreen.css';
import Lottie from 'lottie-react';
import anime1 from '../animations/anime2.json';


const LoadingScreen = () => {
    const [loadingText, setLoadingText] = useState('İçerik yükleniyor...');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const loadingSteps = [
            'Bağlantı kuruluyor...',
            'Kaynaklar yükleniyor...',
            'İçerik hazırlanıyor...',
            'Son dokunuşlar yapılıyor...'
        ];

        let currentStep = 0;

        const progressInterval = setInterval(() => {
            setProgress(prev => {
                const newProgress = Math.min(prev + Math.random() * 15 + 5, 100);

                // Progress'e göre loading text'i güncelle
                const stepIndex = Math.floor((newProgress / 100) * loadingSteps.length);
                if (stepIndex < loadingSteps.length && stepIndex !== currentStep) {
                    setLoadingText(loadingSteps[stepIndex]);
                    currentStep = stepIndex;
                }

                return newProgress;
            });
        }, 200);

        return () => clearInterval(progressInterval);
    }, []);

    return (
        <div className="loading-wrapper" id="loading-wrapper">
            <div className="glow-ring">
                <Lottie animationData={anime1} loop={true} className="loading-animation"/>
            </div>
            <h2 className="loading-title">MeduVR</h2>
            <p className="loading-subtitle">{loadingText}</p>

            {/* Progress Bar */}
            <div className="progress-container">
                <div className="progress-bar">
                    <div
                        className="progress-fill"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <span className="progress-text">{Math.round(progress)}%</span>
            </div>
        </div>
    );
};

export default LoadingScreen;